<template>
  <div class='ProdAction'>
    <div class="nave-search">
      <nave-prod/>
      <input-search
      :placeholder="Empresa.modelo === 'Modelo 03' ? 'Nome do imóvel' : 'Nome do produto'"
      action="SearchNameProdPainel"
      />
    </div>
    <div class="cont-action">
      <div class="cont-add">
        <add-icon
        @click="add"
        text="Adiconar"
        :active="true"
        :optionsLabel="{ width: '100px', marginTop: '90px', marginRight: '50px' }"
        />
      </div>
      <div class="cont">
        <edit-icon
        @click="edit"
        text="Editar"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
      </div>
      <div class="cont">
        <edit-fast-icon
        @click="fastEdit"
        text="Edição rápida"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
      </div>
      <div class="cont">
        <diretory-icon
        v-if="Produtos.filter(p => p.status).length"
        @click="toFile(false)"
        text="Arquivar"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
        <checked-icon
        v-if="!Produtos.filter(p => p.status).length"
        @click="toFile(true)"
        text="Publicar"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
      </div>
      <div @click="view" class="cont">
        <eyes-icon
        :options="{ width: '30px', height: '30px', action: true }"
        text="Visualizar"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
      </div>
      <div @click="copy" class="cont">
        <copy-icon
        :options="{ width: '30px', height: '30px', action: true }"
        text="Copiar"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
      </div>
      <div
      @click="stock"
      class="cont" v-if="Empresa.modelo !== 'Modelo 03'">
        <stock-icon
        :options="{ width: '30px', height: '30px', action: true }"
        text="Gerencimento de estoque"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
      </div>
      <div
      @click="del"
      class="cont">
        <delete-icon
        :options="{ width: '30px', height: '30px', action: true }"
        text="Excluir"
        :active="true"
        :optionsLabel="{ marginTop: '65px' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DeleteIcon from '../../Icons/DeleteIcon'
import CopyIcon from '../../Icons/CopyIcon'
import EyesIcon from '../../Icons/EyesIcon'
import DiretoryIcon from '../../Icons/DiretoryIcon'
import EditFastIcon from '../../Icons/EditFastIcon'
import EditIcon from '../../Icons/EditIcon'
import AddIcon from '../../Icons/AddIcon'
import NaveProd from '../Nave/NaveProd'
import CheckedIcon from '../../Icons/CheckedIcon'
import StockIcon from '../../Icons/StockIcon'
import InputSearch from '../../Search/InputSearch'
export default {
  name: 'ProdAction',
  components: { AddIcon, EditIcon, EditFastIcon, DiretoryIcon, EyesIcon, CopyIcon, DeleteIcon, NaveProd, CheckedIcon, StockIcon, InputSearch },
  computed: {
    ...mapGetters(['SelectedProds', 'StatusProd', 'Empresa', 'Produtos', 'FilterProdPainel']),
    empty () {
      return this.SelectedProds[0].id === ''
    },
    Model () {
      return this.Empresa.modelo === 'Modelo 03'
    }
  },
  methods: {
    ...mapActions(['changeFilterProdPainel', 'GetProduct', 'Loading', 'GetQuantityCopy', 'ClearProdEdit', 'PushProd', 'CopyProd', 'DeleteProd', 'SetModal', 'SetItem01', 'PushMsg', 'ToFileProd', '_UpdateProduct', 'GetProdutoStatus']),
    del () {
      if(this.empty) {
        this.PushMsg({ msg: `Selecione um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: `Tem certeza que deseja excluir o ${ this.Model ? 'imóvel' : 'produto' }?`,
        action: 'DeleteProd',
        payload: this.SelectedProds
      })
    },
    add () {
      this.ClearProdEdit()
        .then(() => {
          this.$router.push('/painel/produtos/register')
        })
    },
    edit () {
      if(this.empty) {
        this.PushMsg({ msg: `Selecione um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      this.$router.push('/painel/produtos/edit')
    },
    fastEdit () {
      if(this.empty) {
        this.PushMsg({ msg: `Selecione um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      if(this.SelectedProds.length > 1) {
        this.PushMsg({ msg: `Selecione apenas um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      this.SetModal({ component: 'FastProdEdit', active: true })
    },
    async copy () {
      if(this.empty) {
        this.PushMsg({ msg: `Selecione um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      let CopyProd = Object.assign({}, this.SelectedProds[0])
      CopyProd.name = CopyProd.name + '-cópia' + await this.GetQuantityCopy(this.SelectedProds[0].name).then(res => res)
      this.PushProd(CopyProd)
        .then(() => {
          this.PushMsg({ msg: `${ this.Model ? 'Imóvel' : 'Produto' } copiado com sucesso.`, color: '#326e3d' })
          this.ClearProdEdit()
        })
    },
    view () {
      if(this.empty) {
        this.PushMsg({ msg: `Selecione um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      if(this.SelectedProds.length > 1) {
        this.PushMsg({ msg: `Selecione apenas um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      this.SetItem01(this.SelectedProds[0])
        .then(() => {
          this.$router.push(`/${this.SelectedProds[0].link}`)
        })
    },
    toFile (payload) {
      if(this.empty) {
        this.PushMsg({ msg: `Selecione um ou mais ${ this.Model ? 'imóveis' : 'produtos' }`, color: '#eba134' })
        return
      }
      for(let key in this.SelectedProds) {
        this.ToFileProd({ status: payload, id: this.SelectedProds[key].id })
          .then(() => {
            this._UpdateProduct(this.SelectedProds[key])
              .then(() => {
                this.GetProdutoStatus(0)
                this.GetProdutoStatus(1)
              })
              .then(() => {
                this.changeFilterProdPainel({ status: payload })
                  .then(() => {
                    this.Loading(true)
                    this.GetProduct({ params: { last: 0, limit: 15, categoria: this.FilterProdPainel.categoria, status: this.FilterProdPainel.status }, init: true })
                      .then(res => {
                        this.produtos = res
                        this.Loading(false)
                      })
                  })
              })
          })
      }
    },
    stock () {
      if(this.empty) {
        this.PushMsg({ msg: `Selecione um ${ this.Model ? 'imóvel' : 'produto' }`, color: '#eba134' })
        return
      }
      this.$router.push('/painel/stock')
    }
  }
}
</script>

<style scoped>
.ProdAction {
  height: 8%;
  display: flex;
  align-items: center;
}

.nave-search {
  width: 60%;
  display: flex;
  justify-content: start;
  align-items: center;
}

.cont-action {
  width: 40%;
  display: flex;
  justify-content: end;
  align-items: center;
}

.cont {
  width: 10%;
}
.cont-add {
  padding-right: 2%;
}

@media (max-width: 500px) {
  .ProdAction {
    display: none;
    height: 15%;
  }
  .nave-search {
    width: 100%;
    justify-content: end;
  }
  .cont-action {
    width: 100%;
  }
}
</style>
